<mat-form-field
    appearance="fill"
    floatLabel="always"
    *ngIf="control"
    class="{{ class }}"
>
    <mat-label>{{ placeholder }}</mat-label>
    <input
        [type]="type"
        (blur)="onControlChange()"
        (keydown.enter)="onControlChange()"
        [formControl]="control"
        [id]="id"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete"
        matInput
    />
    <span matSuffix *ngIf="unit">{{ unit.toLowerCase() }}</span>
</mat-form-field>
